const zh = {
  'Language Key': 'zh',
  'cui-org-info': '组织信息',
  'cui-sign-on-info': '签署信息',
  'cui-user-info': '用户信息',
  'cui-preferences': '优先',
  'cui-review': '评论',
  'cui-org': '组织',
  'cui-company-division': '公司/部门',
  'cui-org-address': '单位地址',
  'cui-user-address': '用户地址',
  'cui-country': '国家',
  'cui-city': '市',
  'cui-state': '州/省',
  'cui-postal': '邮政编码',
  'cui-user-id': '用户名',
  'cui-password': '密码',
  'cui-password-re': '重新输入密码',
  'cui-challenge-question': '挑战问题',
  'cui-challenge-answer': '挑战的答案',
  'cui-favorite-pet-q': '什么是你最喜欢的宠物的名字？',
  'cui-mother-q': '什么是你母亲的娘家姓？',
  'cui-best-friend-q': '谁是你最好的朋友？',
  'cui-first-name': '名字',
  'cui-last-name': '姓',
  'cui-email': '电子邮件',
  'cui-email-re': '重新输入电子邮件',
  'cui-telephone': '电话号码',
  'cui-timezone': '时区',
  'cui-submit': '提交',
  'cui-next': '下一步',
  'cui-previous': '以前',
  'cui-create-security-admin-account': '创建安全管理员帐户',
  'cui-skip-for-now': '暂时略过',
  'icon-library': '图标库',
  'cui-new-TLO': '新的顶级组织',
  'cui-new-TLO-description': '如果你想加入的Covisint Exchange作为一个新的Covisint组织选择此方法',
  'cui-new-division': '新科',
  'cui-new-division-description-start': '选择此方法，如果您想成为',
  'cui-new-division-description-end': '的现有科维森特组织内一个新的部门。',
  'cui-security-administrator': '安全管理员',
  'cui-new-user': '新用户',
  'cui-new-user-description': '如果你是一个现有的Covisint成员企业寻求进入雇员对您的组织订阅，或者如果你不知道，如果你的组织注册的应用程序，请选择此方法。',
  'cui-sign-up': '注册',
  'cui-address': '地址',
  'cui-organization-name': '公司/部门',
  'cui-supplier-code': '供应商代码',
  'cui-address-1': '地址1',
  'cui-address-2': '地址2',
  'cui-user-information': '用户信息',
  'cui-organization-information': '组织信息',
  'cui-sign-in-information': '登录信息',
  'cui-package-selection': '软件包选择',
  'cui-welcome-popover': '安全管理员的职责，详细您选择注册方法后解释。然而，你可以选择取消登记，为的是让Organiziation的不同成员的安全管理员登记。',
  'create-account': '创建您的帐户',
  'cui-agree-covisint': '我同意科维森特',
  'terms-of-service': '服务条款',
  'cui-and': '和',
  'privacy-policy': '隐私政策',
  'cui-tos-agree': '您必须同意服务条款才能继续。',
  'cui-user-profile': '用户资料',
  'cui-my-profile': '我的简历',
  'cui-login': '登录',
  'cui-supplier-content': '此更新一旦设计文件进来，这是谷歌的翻译文档。 Lorem存有。其他的东西。供应商代码的重要信息。我喜欢乌龟。',
  'cui-all-organizations': '所有组织：',
  'cui-application-select-info': '您可以随时登录的第一次后进行选择。',
  'cui-all-applications': '所有应用程序',
  'cui-page-not-found': '找不到网页',
  'cui-page-not-found-content': '您正在寻找可能已被删除或永远的页面已经存在。',
  'cui-home': '家',
  'cui-access-denied': '拒绝访问',
  'cui-access-denied-content': '您无权查看此页。',
  'cui-registration-status': '注册状态',
  'cui-pending-status': '挂起状态',
  'cui-pending-status-content': '您的注册身份仍悬而未决。您会收到一封电子邮件，更多的细节很快。',
  'cui-thank-you': '谢谢',
  'cui-request-submitted': '提交申请',
  'cui-success': '成功',
  'cui-success-content': '您科维森特登记已经成功提交。您会收到一封电子邮件，更多的细节很快。',
  'cui-check-your': '检查你的',
  'cui-registration-status-lower': '注册状态',
  'cui-application-selection': '应用选择',
  'cui-applications': '应用',
  'cui-profile-settings': '配置文件设置',
  'cui-name': '名称',
  'cui-update': '更新',
  'cui-updated': '更新',
  'cui-error-try-again': '错误！再试一次？',
  'cui-back': '背部',
  'cui-selections': '选',
  'cui-add-org': '加入组织',
  'cui-remove-org': '删除组织',
  'cui-select-org': '选择组织',
  'cui-more-information': '更多信息',
  'cui-inv-user-popover-info': '出于安全原因，您必须使用电子邮件邀请您发送登记。这可以用户设置内进行编辑时注册完成。',
  'cui-org-profile': '机构简介',
  'cui-info': '信息',
  'cui-admins': '管理员',
  'lowercase-not-allowed': '没有任何小写字母',
  'uppercase-not-allowed': '没有任何大写字母',
  'numbers-not-allowed': '没有任何数字',
  'special-not-allowed': '没有任何特殊的符号（如：* +）',
  'chars-not-allowed': '不含下列字符：{{disallowedChars}}',
  'words-not-allowed': '不含以下文字：{{disallowedWords}}',
  'password-length': '{{min}}-{{max}}个字符之间',
  'password-rules': '有下列{{requiredNumberOfCharClasses}}种情况：',
  'password-lowercase': '至少1小写字母',
  'password-uppercase': '至少1大写字母',
  'password-number': '至少1个数字',
  'password-special': '至少1个特殊符号（例如：* +）',
  'passwords-must': '密码必须：',
  'welcome-title': '注册为下列之一',
  'cui-application-name': '应用名称',
  'cui-application-tos': '评论条款及条件',
  'cui-application-tos-agreement': '条款和条件协议',
  'cui-package-tos': '您还没有接受选择的软件包条款。',
  'cui-view-tos': '查看条款和条件',
  'password-mismatch': '密码必须匹配',
  'cui-back-to-review': '返回评论',
  'email-mismatch': '电子邮件必须匹配',
  'no-applications-selected': '您没有选择任何应用程序。点击这里回到应用选择。',
  'cui-all-fields-required': '各个领域都需要',
  'cui-complete-registration': '完成下面与您的注册',
  'cui-registered': '注册',
  'cui-open': '打开',
  'cui-close': '关',
  'cui-street-address': '街道地址',
  'cui-zip': '压缩',
  'cui-language': '语言',
  'cui-phone-main': '主要',
  'cui-phone-office': '办公室',
  'cui-phone-fax': '电话/传真',
  'cui-phone-mobile': '移动',
  'cui-save': '保存',
  'cui-cancel': '取消',
  'cui-edit': '编辑',
  'cui-phone': '电话',
  'search-by-app-name': '通过应用程序名称搜索',
  'new-request': '新要求',
  'select-applications': '选择应用程序',
  'browse-applications': '浏览应用',
  'go': '走',
  'filter-list': '筛选器列表',
  'filter': '过滤',
  'owning-org': '拥有组织',
  'my-applications': '我的应用',
  'app-summary': '程序信息',
  'granted': '诚然',
  'bundled-applications': '捆绑的应用程序',
  'application-details': '应用程序详细信息',
  'my-claims': '我的声明',
  'related-applications': '相关应用',
  'review-request': '审查申请',
  'back-to-search': '返回搜索',
  'requested-items': '请求的项目',
  'request-reason': '请求的原因',
  'reason-im-requesting': '原因，我请求',
  'you-must-enter-a-reason': '您必须输入一个理由来请求该应用程序',
  'cui-org-no-applications': '好像你的组织没有任何应用程序。您可以随时登录后再试。',
  'cui-filter-org-name': '按组织名称过滤器',
  'cui-address-example': '公寓，套房，大厦。 （可选的）',
  'cui-filter-app-name': '按应用名称过滤',
  'cui-search-user-name': '搜索用户的名字',
  'page': '页',
  'cui-num-results-page': '结果每页',
  'submit-request': '提交申请',
  'categories': '分类',
  'cui-answer': '回答',
  'cui-enter-password': '输入密码',
  'cui-enter-new-password': '输入新密码',
  'cui-re-enter-new-password': '重新输入新的密码',
  'granted-to-my-org': '授予我的组织',
  'collected-items-for-request': '为请求收集的项目',
  'cui-invalid-password': '无效的密码。请再试一次。',
  'cui-faq': '常问问题',
  'cui-frequently-asked-questions': '经常问的问题',
  'cui-admin-tools': '管理工具',
  'cui-this-field-is-required': '这是必填栏。',
  'cui-this-field-needs-to-be-longer': '该字段需要更长的时间。',
  'cui-you-need-to-agree-to-toc': '您需要在继续之前，同意服务条款。',
  'cui-this-is-not-valid-email': '这不是一个有效的电子邮件。',
  'cui-my-app-requests': '我的应用程序请求',
  'cui-no-claims': '您的这个申请索赔。',
  'cui-no-details': '无详细信息。',
  'request': '请求',
  'all': '所有',
  'no-selected-apps': '您还没有选择任何应用程序。',
  'basic-info': '基本信息',
  'cui-error-username-exists': '用户ID已经存在！请选择另外一个。',
  'password-reset': '重设密码',
  'current-password': '当前密码',
  'timezone-and-language': '时区和语言',
  'challenge-questions': '挑战问题',
  'security-question-repeated': '这个答案已被使用。',
  'cui-by-date-added': '添加日期',
  'cui-alphabetically': '按英文字母顺序',
  'active': '活性',
  'pending': '有待',
  'suspended': '暂停',
  'title': '标题',
  'id': 'ID',
  'url': '网址',
  'privacy-terms': '隐私权与条款',
  'help': '帮帮我',
  'cui-learn-more-start': '学到更多',
  'cui-learn-more-end': '为何我们要求这些信息',
  'cui-org-hierarchy': '组织层次结构',
  'directory': '目录',
  'userID': '用户名',
  'status': '状态',
  'locked': '锁定',
  'rejected': '拒绝',
  'removed': '删除',
  'sort': '分类',
  'refine': '提炼',
  'or': '要么',
  'organizations': '组织',
  'roles': '角色',
  'organization-applications': '组织应用',
  'unactivated': '未激活',
  'log-out': '登出',
  'welcome': '欢迎',
  'privacy': '隐私',
  'terms': '条款',
  'user': '用户',
  'top-level-orgs': '顶级机构',
  'invite-user': '邀请用户',
  'invite-division': '邀请司',
  'username': '用户名',
  'move': '移动',
  'no-bundled-or-related': '没有捆绑或相关的应用程序。',
  'cui-continue': '继续',
  'cui-no-org-divisions': '任何组织和部门',
  'inactive': '待用',
  'deny': '拒绝',
  'approve': '批准',
  'pending-request': '待处理请求',
  'review-approvals': '审查批准',
  'cui-package-no-claims': '该软件包包含任何要求',
  'claims': '声明',
  'package-name': '包裹名字',
  'submit-approvals': '提交审批',
  'view-details': '查看详情',
  'request-date': '查询日期',
  'registration-decision': '登记判定',
  'requested': '要求',
  'getting-user-info': '获取用户信息...',
  'approvals-submitted': '提交审批',
  'rejection-submitted': '拒绝提交',
  'approval-summary': '审批汇总',
  'approved-items': '经过批准的项目',
  'rejected-items': '被拒物品',
  'registration-request-approved': '批准注册请求',
  'registration-request-rejected': '拒绝登记请求',
  'no-items-rejected': '没有项目被拒绝',
  'no-items-approved': '没有项目批准',
  'registration-request': '注册请求',
  'custom-api-loading': '初始化应用...',
  'new-grant': '格兰特应用',
  'search-by-package-name': '通过包名搜索',
  'search': '搜索',
  'administartor-?': '管理员？',
  'submit-grant-update': '提交批更新',
  'review-user-pending-approval': '评测的待批准',
  'view-request-for': '查看请求',
  'job-title': '职称',
  'query': '询问',
  'suspend-app': '暂停应用',
  'new-grants': '新资助',
  'update-grant-settings': '更新格兰特设置',
  'assign-new-grant-to': '分配新赠款',
  'division': '师',
  'redirecting-to-sso': '请求您的凭据',
  'included-applications': '包含的应用',
  'selected-sub-packages': '选定的子包',
  'specify-password': '指定密码',
  'suspend': '暂停',
  'reset-password': '重设密码',
  'confirm-password-reset': '你确定要重置此用户的密码？',
  'yes': '是',
  'within': '中',
  'search-within': '内搜索',
  'in-your-org': '在您的组织',
  'people': '人',
  'revoke-package': '撤销套餐',
  'cui-by-username': '用户名',
  'cui-by-status': '状态',
  'cool-got-it': '酷，得到了它',
  'organization-directory': '组织目录',
  'org-nav-invite-links': '组织导航和链接邀请',
  'org-dir-filters': '组织目录过滤器',
  'org-dir-list': '组织目录列表',
  'apps': '应用',
  'apps-upper': '应用',
  'history-upper': '历史',
  'profile-upper': '简介',
  'roles-upper': '角色',
  'your-app-request-in-review': '您的应用程序的请求已提交',
  'error-generic': '有此页面上加载数据的问题。请再试一次。',
  'cui-application-administrator': '目前没有应用程序管理员，之前用户可以被授予给定应用的管理权限必须分配的作用。这是一个时间设定。',
  'cui-assign-confirm': '你想现在分配这个角色？',
  'cui-suspend-warning': '将无法访问此应用程序',
  'cui-suspend-confirm': '你确定你想现在暂停？',
  'cui-notify-user': '通知用户',
  'cui-users': '用户',
  'cui-no': '没有',
  'cui-remove': '删除',
  'cui-org-abbrev': '组织',
  'cui-userProfile-user-error': '时出错检索用户数据。请再试一次。',
  'cui-userProfile-security-error': '时出错获取安全问题的数据。请再试一次。',
  'cui-userProfile-password-error': '时出错获取密码策略的数据。请再试一次。',
  'cui-suspend-success': '本申请现在是从所选择的用户暂停',
  'cui-unlock': '开锁',
  'cui-unlock-password-confirm': '你确定你想解开这个用户的密码？',
  'cui-error-unlocking-password': '对不起，出现了错误解锁这个用户的密码。',
  'cui-error-person-request': '无法检索登记请求数据为该用户。',
  'cui-error-email-exists': '电子邮件地址已被占用',
  'cui-password-history-rule': '不符合你以前的{{numberOfPasswords}}密码',
  'cui-password-policy': '密码策略',
  'cui-security-admin': '安全管理员',
  'cui-button-loading-text': '载入中...',
  'cui-username-taken': '用户名已存在',
  'cui-no-applications': '您目前没有任何应用程序',
  'cui-mask-answers': '面膜/取消屏蔽安全答案',
  'cui-pwd-reset-success': '密码重置成功！',
  'cui-last-login': '上次登录',
  'cui-need-different-app': '需要不同的应用程序',
  'cui-go-back-to': '回到',
  'cui-tos-applications': '请接受条款及条件所选择的应用',
  'cui-selected-apps': '选定的应用',
  'cui-authentication-policy': '验证策略',
  'cui-selected': '选',
  'cui-tac': '条款和条件',
  'cui-accept': '接受',
  'cui-tac-agree': '您必须同意条款和条件继续。',
  'cui-printer-friendly-tac': '打印的条款和条件',
  'cui-my-history': '我的历史',
  'cui-status-history': '我的状态历史记录',
  'cui-app-history': '应用历史',
  'cui-password-change-log': '密码更改日志',
  'cui-date': '日期',
  'cui-event-type': '事件类型',
  'cui-action-by': '通过行动演出',
  'cui-notes': '笔记',
  'cui-try-again': '请再试一次。',
  'cui-password-change-log-error': '发生错误检索密码更改日志。',
  'cui-userstatus-history-error': '时出错获取用户状态的历史。',
  'cui-claims-error': '时出错检索索赔。',
  'cui-org-app-suspend-success': '此应用程序现在是从选定的组织，所有用户，所有的子机构暂停。',
  'cui-org-app-suspend-msg1': '在积极利用时，该操作将暂停从所有用户和子组织的行动均匀。',
  'cui-org-app-suspend-msg2': '您确定要暂停',
  'cui-from': '从',
  'cui-application-granted-history': '申请资助的历史',
  'cui-application-requested-history': '应用程序请求历史',
  'approved': '批准',
  'decision': '决策',
  'evaluator': '计算器',
  'action': '行动',
  'cui-invalid-invitation': '邀请是不是已经使用或无效',
  'cui-by-request-date': '查询日期',
  'cui-by-decision-date': '决定日期',
  'cui-no-orgs-for-name': '未找到指定名称的组织。请使用其他名称再试。',
  'requests': '要求',
  'no-pending-apps': '您没有待处理的应用程序请求。',
  'description': '描述',
  'launch': '发射',
  'manage-applications': '管理应用程序',
  'request-type': '请求类型',
  'phase': '相',
  'date-submitted': '提交日期',
  'cui-pending-requests-error': '有在检索/更新需求的错误。',
  'no-requests-by-name': '未找到指定名称的请求。请使用其他名称再试。',
  'cannot-change-password': '现在不能更改密码',
  'select-claims': '选择索赔',
  'grant-reason': '格兰特原因',
  'grants-assigned': '新的拨款分配',
  'suspend-error': '有挂起请求错误。',
  'unsuspend-error': '有在取消暂停请求错误。',
  'approval': '赞同',
  'administrator': '管理员',
  'submitted': '提交',
  'no-bundled': '没有捆绑应用',
  'disallowed-password-rule': '不能包含不允许的单词列表上的词',
  'request-approve-or-rejected': '该请求被批准或者/拒绝',
  'application': '应用',
  'show-all': '显示所有',
  'cui-subject': '学科',
  'cui-es': '（ES）',
  'cui-invite-user': '邀请中的用户',
  'cui-invite-user-success': '您的用户邀请请求发送',
  'cui-email-recipt': '输入收件人的电子邮件（用逗号分隔多个）',
  'cui-invite-verbiage': '邀请下列之一',
  'select': '选择',
  'change-org': '更改组织',
  'cui-invite-user-sub': '注册成为用户加入',
  'cui-invite-user-select': '搜索的组织',
  'cui-send-invitation': '发送邀请',
  'invite': '邀请',
  'cui-invite-tlo-success': '您的顶层机构邀请请求发送',
  'cui-invite-tlo': '邀请一个新的组织',
  'cui-invite-division-success': '贵公司邀请请求发送',
  'cui-invite-division': '邀请的组织',
  'cui-tlo-sub': '注册为一个新的组织',
  'cui-division-sub': '注册成为内的管理员联系',
  'search-by-org-name': '按组织名称搜索',
  'app-approval-error': '有审批App请求错误。',
  'modify-claims': '变更诉讼请求',
  'unsuspend-app': '取消暂停应用',
  'remove-app': '移除应用程式',
  'user-details': '用户详细信息',
  'reason': '原因',
  'required': '需要',
  'cui-unsuspend-confirm': '你确定你现在想取消挂起？',
  'unsuspend': '取消暂停',
  'remove-confirm': '你确定你想立即删除？',
  'remove': '去掉',
  'my-organization': '我的组织',
  'request-app': '请求应用程序',
  'no-apps-found': '找不到应用。',
  'refine-search': '请改进搜索标准。',
  'your-assign-role-success': '分配新角色',
  'cui-assigned-roles': '分配的角色',
  'cui-available-roles': '可用角色',
  'cui-browse-by-category': '按类别浏览',
  'cui-back-navigation-requests': '返回导航和要求',
  'cui-search-results': '搜索结果',
  'cui-new-grant-search-results': '新资助搜索结果',
  'cui-username-close': '用户名和关闭导航',
  'cui-user-no-apps': '用户没有应用',
  'cui-no-roles-assigned': '该用户没有指定的角色。',
  'status-history': '状态历史记录',
  'cui-no-status-history': '该用户没有地位的历史。',
  'cui-pwd-reset-msg1': '密码重置成功。新密码是：',
  'cui-pwd-reset-msg2': '注意：如果你只看到上半年密码，然后下半年密码将被发送到用户的注册邮箱。',
  'users-upper': '用户',
  'hierarchy-upper': '层次',
  'privileges': '特权',
  'expand-all': '展开全部',
  'collapse-all': '全部收缩',
  'no-records': '没有找到记录。',
  'contact-us': '联系我们',
  'cui-error-organization-request': '无法检索登录请求数据这一组织。',
  'cui-error-organization-app-request': '无法检索应用程序请求数据为这个组织',
  'cui-error-user-app-request': '无法检索应用程序请求数据此用户',
  'assign': '分配',
  'search-by-person-name': '按人名搜索',
  'grant-history': '格兰特历史',
  'request-history': '申请历史纪录',
  'social-login': '社会登录',
  'facebook': 'Facebook的',
  'twitter': '推特',
  'link': '链接',
  'unlink': '取消链接',
  'invalid-url': '这不是一个有效的URL。',
  'linkedin': 'LinkedIn',
  'google': '谷歌',
  'administration': '行政',
  'services': '服务',
  'n-phase': 'N  - 审批阶段',
  'edit-package': '编辑包',
  'is-requestable': '是可请求',
  'is-displayable': '是可显示',
  'is-grantable': '是可授权',
  'require': '要求',
  'is-requestable-desc': '指出是否用户可以请求该应用程序。',
  'is-grantable-desc': '指出如果此应用程序可直接由公司管理授予用户',
  'is-displayable-desc': '表明如果包图标应该在我的应用程序页面显示',
  'require-reason-desc': '指出如果此包所需要的用户提供一个理由，要求该包',
  'company-admin': '公司管理',
  'application-admin': '应用管理',
  'company-admin-desc': '这是默认的审批阶段，它应该是如果不需要其他阶段',
  'application-admin-desc': '是否用户应用请求，需要由应用程序管理员的批准？',
  'add-admins': '添加管理员',
  'cardinality-indicator': '基数指标',
  'cui-one': '一',
  'cui-many': '许多',
  'claim-values': '声明值',
  'cui-add': '加',
  'cui-view': '视图',
  'cui-claim': '要求',
  'cui-category': '类别',
  'cui-service': '服务',
  'cui-delete': '删除',
  'federation-conn': '联邦连接',
  'updated-date': '更新日期',
  'target-url': '目标网址',
  'remote-app-id': '远程应用程序标识',
  'mobile-sso-url': '移动SSO网址',
  'mobile-app-id': '移动应用ID',
  'cui-package': '包',
  'cui-create': '创建',
  'more-languages': '更多的语言',
  'duplicate-language-error': '重复的语言不允许',
  'cui-nextstep': '下一个',
  'create-package': '创建包',
  'manage-package-claims': '管理软件包索赔',
  'cardinality-indicator-error': '基数指标不能一个',
  'value-id-exists': '值标识已经存在',
  'claim-id-exists': '声明ID已经存在',
  'cui-new': '新',
  'package-success-content': '已成功创建套件',
  'add-claims': '添加索赔',
  'package-update-success': '已成功更新套件'
}
export {
  zh
}



// WEBPACK FOOTER //
// ./src/plugins/i18n/zh.js